import { FileDownload, useHttpClient } from '@shared/http';

export interface TherapeuticClassExportParams {
  classificationId: number;
  drugIds: number[];
  coverageTagIds?: number[];
  stateIds?: number[];
  poolIds?: number[];
  paTypeIds?: number[];
  pdlStatuses?: string[];
}

export const useTherapeuticClassExportService = () => {
  const httpClient = useHttpClient();

  const exportToCSV = (params: TherapeuticClassExportParams): Promise<FileDownload> => {
    // Prepare the request body for POST
    const requestBody = {
      classificationId: params.classificationId,
      drugIds: params.drugIds?.length ? params.drugIds : null,
      coverageTagIds: params.coverageTagIds?.length ? params.coverageTagIds : null,
      stateIds: params.stateIds?.length ? params.stateIds : null,
      poolIds: params.poolIds?.length ? params.poolIds : null,
      paTypeIds: params.paTypeIds?.length ? params.paTypeIds : null,
      pdlStatuses: params.pdlStatuses?.length ? params.pdlStatuses : null
    };

    // Use POST method with request body as defined in the backend endpoint
    return httpClient.download('POST', 'reports/therapeutic-class/export', { data: requestBody });
  };

  return {
    exportToCSV,
  };
};
